import { gql as a } from "@apollo/client";
const t = a`
  mutation SendSetUpEmailAndPasswordOTP($email: String!) {
    sendSetUpEmailAndPasswordOTP(input: { email: $email })
  }
`;
export {
  t as default
};
//# sourceMappingURL=sendSetupEmailAndPasswordOTP.js.map
